import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { INPUT_CLS, INPUT_ERROR_CLS } from 'helpers/formStyles';

/**
 * PasswordInput — Input with a reveal toggle.
 *
 * Typing a password you cannot see is how people end up setting one they cannot
 * reproduce, then asking for another reset link. Works uncontrolled
 * (react-hook-form `register`) or controlled, like Input.
 */
const PasswordInput = React.forwardRef(({ error = false, className = '', ...rest }, ref) => {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="tw-relative">
      <input
        ref={ref}
        type={revealed ? 'text' : 'password'}
        className={classNames(INPUT_CLS, 'tw-pr-9', error && INPUT_ERROR_CLS, className)}
        {...rest}
      />
      <button
        type="button"
        // Nothing here is a form action; without this the toggle submits the form.
        onClick={() => setRevealed((shown) => !shown)}
        aria-label={revealed ? 'Hide password' : 'Show password'}
        className="tw-absolute tw-right-0 tw-top-0 tw-h-full tw-px-2.5 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-slate-400 hover:tw-text-slate-600"
      >
        {revealed ? <LuEyeOff /> : <LuEye />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

PasswordInput.propTypes = {
  error: PropTypes.bool,
  className: PropTypes.string
};

export default PasswordInput;
